import { render, staticRenderFns } from "./Modal-images.vue?vue&type=template&id=5be1be6c&scoped=true&"
import script from "./Modal-images.vue?vue&type=script&lang=js&"
export * from "./Modal-images.vue?vue&type=script&lang=js&"
import style0 from "./Modal-images.vue?vue&type=style&index=0&id=5be1be6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be1be6c",
  null
  
)

export default component.exports